module.exports = __webpack_public_path__ + "static/installation-9f52f86f98ef6509a8541f602f118de9.jpg";